import React, { FC } from "react";
import Input from "../input/Input";
import { ComposantAllProps } from "composants/common";
import { format } from "date-fns";
import { useMacOSDatePicker } from "utils/platform.utils";

export interface CalendarHoursSecondesProps extends ComposantAllProps {
  defaultAppearance?: boolean;
}

export const CalendarHoursSecondes = ({
  value,
  defaultAppearance,
  ...restProps
}: CalendarHoursSecondesProps) => {
  const finalValue = format(value, "YYYY-MM-DDTHH:mm:ss");
  const { inputRef, isMacOS, handleFocus, handleMouseDown } = useMacOSDatePicker();

  return (
    <Input
      {...restProps}
      ref={inputRef}
      data-initial-appearance={defaultAppearance || isMacOS}
      type="datetime-local"
      value={value ? finalValue : ""}
      data-value={value ? finalValue : ""}
      step="1"
      onFocus={e => handleFocus(e, restProps.onFocus)}
      onMouseDown={e => handleMouseDown(e, restProps.onMouseDown)}
    />
  );
};

export default CalendarHoursSecondes;
